"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformObject = void 0;
class TransformObject {
    constructor(parent, sharedData, deduplicationKey, allowedChildTypes = new Set(), context) {
        this.allowedChildTypes = allowedChildTypes;
        this.parent = parent;
        this.deduplicationKey = deduplicationKey;
        this._sharedData = sharedData;
        if (context) {
            this.context = context;
        }
        else {
            this.context = parent?.context;
        }
    }
    linkTo(primary) {
        if (primary === this) {
            throw new Error('Cannot link object to itself');
        }
        if (primary.deduplicationKey !== this.deduplicationKey) {
            throw new Error('Cannot link objects with different deduplication keys');
        }
        if (this.deduplicationKey === undefined) {
            throw new Error('Cannot link objects with no deduplication key');
        }
        if (this._sharedData?.compiled !== undefined) {
            throw new Error('Cannot link object that has already compiled');
        }
        this._sharedData = primary._sharedData;
    }
    get compiled() {
        if (this._sharedData === undefined) {
            this._sharedData = {};
        }
        if (this._sharedData.compiled === undefined) {
            const start = performance.now();
            this._sharedData.compiled = this.compile();
            this._sharedData._compilationTimeMs = performance.now() - start;
        }
        return this._sharedData.compiled;
    }
    get isCompiled() {
        return this._sharedData?.compiled !== undefined;
    }
    canAdd(child) {
        for (const type of this.allowedChildTypes) {
            if (child instanceof type) {
                return true;
            }
        }
        return false;
    }
    assertCanAdd(child) {
        if (!this.canAdd(child)) {
            throw new Error(`${this.constructor.name} cannot add child of type ${child.constructor.name}`);
        }
    }
    add(_child) {
        throw new Error(`${this.constructor.name} does not accept children`);
    }
    get dependencies() {
        return [];
    }
    get creates() {
        return [];
    }
    findParent(type) {
        let current = this;
        while (current !== undefined) {
            if (current instanceof type) {
                return current;
            }
            current = current.parent;
        }
        return undefined;
    }
    requireParent(type) {
        const parent = this.findParent(type);
        if (!parent) {
            throw new Error(`${this.constructor.name} requires a parent of type ${type.name}`);
        }
        return parent;
    }
    static FindParent(object, type) {
        let current = object.parent;
        while (current !== undefined) {
            if (current instanceof type) {
                return current;
            }
            current = current.parent;
        }
        throw new Error(`${object.constructor.name} requires a parent of type ${type.name}`);
    }
}
exports.TransformObject = TransformObject;
//# sourceMappingURL=TransformObject.js.map